<template>
    <span class="markdown" v-html="converted_text"></span>            
</template>

<script setup>
import markdownit from 'markdown-it'

const props = defineProps(['text'])
const md = markdownit()
const converted_text = md.render(props.text);
</script>

<style lang="scss" scoped>
:deep(ul) { list-style-type: disc; }
:deep(ul li) { margin-left: 20px; }
:deep(p) { margin: 20px 0px; }
:deep(a) { display: none; }
</style>
